async function apiGet(path) {
  const res = await fetch(path);
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `API error ${res.status}`);
  }
  return data;
}

export function fetchApiHealth() {
  return apiGet('/api/health');
}

export function fetchCompetitions() {
  return apiGet('/api/v1/competitions');
}

export function fetchRoster(competitionId) {
  const params = new URLSearchParams({ competitionId });
  return apiGet(`/api/v1/roster?${params}`);
}

export function fetchWidgetData(competitionId, type, options = {}) {
  const params = new URLSearchParams({ competitionId, type });
  if (options.featuredMatchId) params.set('featuredMatchId', options.featuredMatchId);
  if (options.selectedTeam) params.set('selectedTeam', options.selectedTeam);
  if (options.selectedPlayer) params.set('selectedPlayer', options.selectedPlayer);
  return apiGet(`/api/v1/widget-data?${params}`);
}

export function fetchMatchList(competitionId) {
  const params = new URLSearchParams({ competitionId });
  return apiGet(`/api/v1/matches?${params}`);
}
